import { TabsOverrides, TabOverrides, SharedProps } from 'baseui/tabs';
import { DARK_MUTED } from '@lyon/utils/theme/colors/darkmuted';

export const TABS: TabsOverrides<SharedProps> = {
  Root: {
    style: {
      boxSizing: 'border-box',
      height: '100%',
    },
  },
  TabBar: {
    style: ({ $theme }) => ({
      paddingLeft: 0,
      paddingRight: 0,
      backgroundColor: DARK_MUTED.darkmuted700,

      [$theme.mediaQuery.medium]: {
        display: 'flex',
      },
    }),
  },
  TabContent: {
    style: ({ $theme }) => ({
      height: '100%',
      paddingLeft: 0,
      paddingRight: 0,
      color: $theme.colors.primaryA,
    }),
  },
};

export const TAB: TabOverrides<SharedProps> = {
  Tab: {
    style: ({ $active, $disabled, $theme }) => ({
      color: $active ? $theme.colors.white : $theme.colors.primaryA,
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
      paddingTop: '8px',
      paddingLeft: '32px',
      paddingRight: '32px',
      paddingBottom: '8px',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottom: `
        ${$active ? '3px' : 0}
        ${$active ? 'solid' : 'none'}
        ${$active ? $theme.colors.primary : 'none'}
      `,
      ...$theme.typography.font250,

      backgroundColor: $active
        ? DARK_MUTED.darkmuted500
        : DARK_MUTED.darkmuted600,

      ':hover': $disabled
        ? {}
        : {
          color: $theme.colors.white,
        },
      ':focus': $disabled
        ? {}
        : {
          color: $theme.colors.white,
        },
    }),
  },
};
